import { debounce } from 'debounce';

class Ads {

   constructor(options) {

    var defaults = {
      param: '',
      breakpoints: [
        300,
        969
      ],
      devices: [
        'mobile',
        'desktop'
      ],
    };

    this.params = Object.assign({}, defaults, options || {});

    this.previousViewport = null;
    this.currentViewport = null;
    this.firstLoad = true;

    this.adElements = document.querySelectorAll('.frm-ad-slot');

    this.setViewport();
    this.showAds();
    this.addEvents();
  }

  addEvents() {
    window.addEventListener('resize', debounce((event) => {

      this.firstLoad = false;

      this.setViewport();

      if (this.adSlots.length && this.previousViewport != this.currentViewport) {
        googletag.destroySlots(this.adSlots);

        this.showAds();

        this.previousViewport = this.currentViewport;
      }
    }, 500));
  }

  refreshAds() {
    this.adElements = document.querySelectorAll('.frm-ad-slot');
    this.setViewport();
    this.showAds();
  }

  showAds() {

    this.adSlots = [];

    var elementsTotal = this.adElements.length;

    for (var index = 0; index < elementsTotal; index++) {
      var el = this.adElements[index];

      if (el.getAttribute('data-settings'))
      {
        var adSlot = JSON.parse(el.getAttribute('data-settings'));

        if (adSlot.devices.indexOf(this.currentViewport) > -1) {
          el.removeAttribute('data-settings');
          this.renderAdSlot(adSlot);
        }
      }
    }
  }

  renderAdSlot(adSlot) {

    googletag.cmd.push(() => {

      var mapping = null;

      var slot = googletag.defineSlot('/' + adSlot.publisher + '/' + adSlot.slot, adSlot.sizes, adSlot.position);
      console.log(adSlot.slot, ' ', adSlot.position);

      if (mapping) {
        slot.defineSizeMapping(mapping);
      }

      slot.addService(googletag.pubads());
      this.adSlots.push(slot);
      googletag.display(adSlot.position);

    });
  }

  destroyAd() {
    if (typeof googletag.pubads !== 'function') {
      return;
    }
  }

  setViewport() {

    var windowWidth = this.getWindowWidth();

    if (this.firstLoad == false) {
      this.previousViewport = this.currentViewport;
    }

    for (var i = 0; i < this.params.breakpoints.length; i++) {
      if (windowWidth >= this.params.breakpoints[i]) {

        this.currentViewport = this.params.devices[i];
      }
    }

    if (this.firstLoad == true) {
      this.previousViewport = this.currentViewport;
    }

  }

  getWindowWidth() {
    return window.innerWidth || document.documentElement.clientWidth;
  }

}

export {
    Ads as
    default
};
